import { GetApp } from "../../App"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { LoginInvitationViewProps } from "./Params"

export function LoginInvitationView({ loading, acceptInvitation, useOtherAccount, loginError }: LoginInvitationViewProps) {
  const app = GetApp()!;
  const t = app.getT("LoginView");

  return (
    <div className="invitation-actions">
      <Block className="invitation-actions-block">
        {loginError && <div className="LoginView-error">{t(`error_${loginError}`)}</div>}
        <BlockRow actions={true} className="invitation-buttons">
          <BlockField><button className="button" onClick={useOtherAccount} disabled={loading}>{t("invitation_use_other_account")}</button></BlockField>
          <BlockField><button className="button default" onClick={acceptInvitation} disabled={loading}>{t("invitation_accept")}</button></BlockField>
        </BlockRow>
      </Block>
    </div>
  );
}
